module.exports = __webpack_public_path__ + "img/sii--icon.3f67efa1.png";